import { useSelector } from 'react-redux'
import { deployPermissionUsersForCurrentBotSelector } from '../selectors'

export function useDeployPermissionUsers() {
  return useSelector(deployPermissionUsersForCurrentBotSelector)
}
